export const createRatingStars = (rate: string) => {
    const parts = rate.split('.');
    const first = parts[0];
    const secondStr = parts[1]?.slice(0, 2);
    let second;

    if (secondStr) {
        if (secondStr.length > 1) {
            // if rating 4.08 or 4.38
            second = +secondStr;
        } else {
            // if rating 4.8
            second = +secondStr * 10;
        }
    } else {
        // if rating 4
        second = 0;
    }

    return {
        full: second > 74 ? +first + 1 : +first,
        half: second > 29 && second < 75 ? 1 : 0,
    };
};
